<ifc-app-card [asideOrderLtLg]="-1" [asideHideXS]="true" [fxLayoutDirection]="'row'" fxLayout="row" fxLayout.gt-md="row"
  fxFlexAlign.lt-lg="center center" class="sign-in-panel">
  <aside class="sign-up">
    <div class="flex column start-start">
      <p class="mat-headline-2 title">Let's do this!</p>
      <div class="user-aside-hr"></div>
      <p *ngIf="branding?.colorSchema === companyColorSchema.IdeaFinancial; else levelEsq" class="mat-headline-4 aside">Realize Your Next <br />Opportunity with <br />{{branding?.dba || branding?.name}}</p>
      <ng-template #levelEsq>
        <p class="mat-headline-4 aside">Raise the bar with<br />{{branding?.dba}}</p>
      </ng-template>
    </div>
  </aside>
  <div class="flex column start-start sign-up">
    <p class="mat-headline-5">
      Create an account
    </p>
    <form class="flex column" (ngSubmit)="submit()" [formGroup]="form">
      <mat-form-field appearance="outline" class="field">
        <mat-label>Email</mat-label>
        <input id="email" matInput placeholder="Email" autocomplete="email" required formControlName="email">
        <mat-error *ngIf="form.controls.email.hasError('notUnique'); else emailCommonError">
          {{form.controls.email.getError('notUnique')}}
        </mat-error>
        <ng-template #emailCommonError>
          <mat-error>
            Please enter a valid email address.
          </mat-error>
        </ng-template>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field">
        <mat-label>Registration token</mat-label>
        <input matInput placeholder="Registration token" autocomplete="off" required formControlName="otp">
        <mat-error>
          Please enter registration token.
        </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field">
        <mat-label>Password</mat-label>
        <input matInput type="password" placeholder="Password" autocomplete="new-password" required formControlName="password">
        <mat-hint>
          Min. of 8 characters, 1 uppercase and 1 lowercase letter, 1 number
        </mat-hint>
      </mat-form-field>
      <mat-form-field appearance="outline" class="field">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" placeholder="Confirm your password" autocomplete="new-password" required
          formControlName="confirmPassword">
        <mat-hint>
          Your password and confirmation must match
        </mat-hint>
      </mat-form-field>
      <div class="flex row center-center login-button-row">
        <span class="user-sign-up-form-opt-in-label">
          By registering an account, I agree to be contacted by {{branding?.dba || branding?.name}} via call, email, and text.
          To opt-out, you can reply 'Stop' at any time or click the unsubscribe link in the emails.
          Message and data rates may apply.
        </span>
        <button mat-flat-button color="primary" type="submit"
          [disabled]="loading">Continue</button>
        <span class="user-sign-in-form-submit-label">or</span>
        <ifc-google-sign-in-button context="signup_with"
          (signInSuccess)="googleSignInSuccess($event)">
        </ifc-google-sign-in-button>

        <ifc-apple-sign-in-button context="sign-up" (signInSuccess)="appleSignInSuccess($event)">
        </ifc-apple-sign-in-button>
      </div>
      <div class="margin margin-left-0 margin-bottom-0 sign-in">
        Have an account? Click <a (click)="navigateToSignIn()">here</a> to login.
      </div>
    </form>
  </div>
</ifc-app-card>
<ifs-ssl-info></ifs-ssl-info>
